import { styled } from '@mui/material'

export const BlockContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'blockCss',
})<{ blockCss: boolean }>`
  ${({ blockCss }) => blockCss}
`
